import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=97c0b676&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=97c0b676&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c0b676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97c0b676')) {
      api.createRecord('97c0b676', component.options)
    } else {
      api.reload('97c0b676', component.options)
    }
    module.hot.accept("./Attachment.vue?vue&type=template&id=97c0b676&scoped=true", function () {
      api.rerender('97c0b676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/preapprovedInvoices/Attachment.vue"
export default component.exports